import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const legalreportOvertimeReport = ({ dispatch, params, format, responseType, successCallback, callback }) => {
  ApiService.request('get', `/legalreports/overtime_reports/overtime_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const legalAttendanceReport = ({ dispatch, params, format, responseType, successCallback, callback }) => {
  ApiService.request('get', `/legalreports/attendance_reports/attendance_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const legalAttendanceProofReport = ({ dispatch, params, format, responseType, successCallback, callback }) => {
  ApiService.request('get', `/legalreports/attendance_reports/attendance_proof${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const legalreportOffdaysReport = ({ dispatch, params, format, responseType, successCallback, callback }) => {
  ApiService.request('get', `/legalreports/holiday_reports/offdays_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const legalreportWorkdayReport = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/legalreports/workday_reports/workinghours_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const legalreportShiftReport = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/legalreports/shift_reports/shifts_modification${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const markingCorrectionAttendanceReport = ({
  dispatch,
  params,
  format,
  responseType,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/legalreports/marking_correction_reports/index${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const markingCorrectionUpdate = ({ dispatch, params, successCallback, callback }) => {
  ApiService.request('post', `/legalreports/marking_correction_reports/update`, {
    dispatch,
    params,
    successCallback,
    callback
  });
};
export const dailyAttendancesReport = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/legalreports/daily_attendances/export${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const legalReportSimpleReport = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/simple_reports/simple_reports${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const shiftSummaryReportRequest = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/shift_summary_reports/shift_summary_reports/index${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const debounceLegalreportWorkdayReport = AwesomeDebouncePromise(legalreportWorkdayReport, 300);
export const debounceDailyAttendancesReport = AwesomeDebouncePromise(dailyAttendancesReport, 300);
export const debounceLegalReportSimpleReport = AwesomeDebouncePromise(legalReportSimpleReport, 300);
export const debounceShiftSummaryReportRequest = AwesomeDebouncePromise(shiftSummaryReportRequest, 300);
